export {initProdTileCarousel, unslickProdTileCarousel};

const IMAGE_CONTAINER_CAROUSEL_CLASS = '.js-prodTile-imageContainer-carousel';

function initProdTileCarousel(containerClass) {
    const $tileCarousel = containerClass
        ? $(containerClass + ' ' + IMAGE_CONTAINER_CAROUSEL_CLASS)
        : $(IMAGE_CONTAINER_CAROUSEL_CLASS);

    if ($tileCarousel) {
        loadLazyVideo();
        $tileCarousel.on('init', function () {
            $(this).find('.slick-arrow').addClass('js-prevent-link');
            $(this).find('.slick-dots').addClass('js-prevent-link');
        });
        $tileCarousel.slick({
            lazyLoad: 'ondemand',
            draggable: true,
            dots: true,
            accessibility: false,
            arrows: true,
            responsive: [
                {
                    breakpoint: 1023,
                    settings: {
                        arrows: false,
                    },
                },
            ],
        });
    }
}

function unslickProdTileCarousel(containerClass) {
    const $tileCarousel = containerClass
        ? $(containerClass + ' ' + IMAGE_CONTAINER_CAROUSEL_CLASS + '.slick-initialized')
        : $(IMAGE_CONTAINER_CAROUSEL_CLASS + '.slick-initialized');

    if ($tileCarousel) {
        $tileCarousel.slick('unslick');
    }
}

function loadLazyVideo() {
    const lazyloadclass = 'js-customLazyload';
    let lazyVideos = [].slice.call(document.querySelectorAll('.' + lazyloadclass));

    let lazyVideoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (video) {
            if (video.isIntersecting) {
                for (let source in video.target.children) {
                    let videoSource = video.target.children[source];
                    if (
                        typeof videoSource.tagName === 'string' &&
                        videoSource.tagName === 'SOURCE'
                    ) {
                        videoSource.src = videoSource.dataset.src;
                    }
                }

                video.target.load();
                video.target.classList.remove(lazyloadclass);
                lazyVideoObserver.unobserve(video.target);
            }
        });
    });

    lazyVideos.forEach(function (lazyVideo) {
        lazyVideoObserver.observe(lazyVideo);
    });
}
